import React, { useEffect, useState } from "react";
import TitleBar from "../../components/TitleBar";
import { connect, useSelector } from "react-redux";
import { mapVtrStateToProps } from "../../services/mapStateToProps";
import { Button, Divider } from "@mui/material";
import { Link, Navigate, useLocation } from "react-router-dom";
import EffortReviewNav from "../../components/EffortReviewNav";
import ErrorAlert from "../../components/ErrorAlert";
import CatchReview from "../../components/CatchReview";
import { mapDispatchToProps } from "../../constants/dispatchNewTripForm";
import { displayLatitudeLongitude } from "../../constants/Effort";
import { getCurrentOpenTrip } from "../../constants/vtrTrip";
import Spinner from "../../components/common/Spinner";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Box, Grid } from "@mui/material";
import DeleteEffort from "./DeleteEffort";
import { getFieldLabel } from "../../constants/Helpers";
import useDisplayLobsterQuestions from "../../constants/useDisplayLobsterQuestions";

function EffortReviewPage(props) {
  const { actions } = props;
  const { vtrTrip, auth, validation } = useSelector((state) => state);
  const [effortNr, setEffortNr] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isExisting, setIsExisting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentTrip, setCurrentTrip] = useState({});
  const location = useLocation();
  const styles = {
    button: {
      justifyContent: "space-between",
      color: "ButtonText",
    },
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    //Reset Trip state in redux to display correct data
    actions.setTrip(auth.client_id);
    let openTrip = getCurrentOpenTrip(
      vtrTrip.allOpenTrips,
      location.state.trip_id
    );
    if (Object.keys(openTrip).length > 0) {
      const effortNr = location.state.effortNr;
      // * catch
      openTrip.catchNr = 0;
      setIsExisting(true);
      if (
        openTrip.images &&
        openTrip.images.length > 0 &&
        openTrip.images.hasOwnProperty(effortNr) &&
        openTrip.images[effortNr] &&
        openTrip.images[effortNr].hasOwnProperty("catch")
      ) {
        let catches = openTrip.images[effortNr].catch;
        if (Array.isArray(catches)) {
          openTrip.catchNr = catches.length;
        }
      }
      setCurrentTrip(openTrip);
      setEffortNr(effortNr);
    }
    setIsLoaded(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _showConfirm = (event) => {
    event.preventDefault();
    setShowModal(true);
  };
  const GearJson = validation.validations.gear;
  const [
    displayTrapsPerEffortQuestion,
    ,
    displayTrapsInWaterQuestion,
    ,
    displayLinesInWaterQuestion,
    ,
    displayTrapsPerStringQuestion,
    ,
    ,
    ,
    ,
    displayStringsHauledPerEffortQuestion,
    ,
    displayAverageSoakTimePerEffortQuestion,
  ] = useDisplayLobsterQuestions(currentTrip, effortNr, GearJson);

  if (isLoaded === false) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }

  if (vtrTrip.redirect === true && isLoaded) {
    return (
      <Navigate
        replace
        to={`${process.env.PUBLIC_URL}/vtr-trip-review`}
        state={{
          trip_id: currentTrip.trip_id,
          client_id: auth.client_id,
        }}
      />
    );
  }

  if (currentTrip && currentTrip.trip_id && effortNr !== undefined) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Box width="100%">
          <TitleBar
            title={"Effort: " + (effortNr + 1)}
            delete_button={isExisting === true ? _showConfirm : false}
            client_id={auth.client_id}
            trip_id={currentTrip.trip_id}
            effort_id={effortNr}
          />
        </Box>
        {showModal && (
          <DeleteEffort
            isVisible={showModal}
            setIsVisible={setShowModal}
            client_id={auth.client_id}
            trip_id={currentTrip.trip_id}
            effortNr={effortNr}
            handleAction={actions.deleteEffort}
          />
        )}
        <Box justifyContent={"center"} alignItems={"center"} width={"auto"}>
          <Grid item xs={8}>
            <h3 align="center">{`Trip id: ${
              currentTrip.submission_type.toUpperCase() === "PAPER"
                ? currentTrip.lowest_serial_num
                : currentTrip.trip_id
            }`}</h3>
          </Grid>
          <Divider />
          <Grid item xs={8}>
            {currentTrip.images.map((effort, idx) => {
              if (effortNr === undefined || effortNr === idx) {
                return (
                  <div key={"trip_" + idx}>
                    <Divider />
                    <Link
                      to={`${process.env.PUBLIC_URL}/effort-page1`}
                      state={{
                        trip: currentTrip,
                        effortNr: idx,
                      }}
                      className="side-nav"
                    >
                      <Button
                        fullWidth
                        style={styles.button}
                        endIcon={<NavigateNextIcon />}
                      >
                        {"Gear Code: " + effort.gearcode}
                      </Button>

                      <Divider />
                      <Button
                        fullWidth
                        style={styles.button}
                        endIcon={<NavigateNextIcon />}
                      >
                        {"Gear Quantity: " +
                          (effort.gearqty ? effort.gearqty : "N/A")}
                      </Button>
                      <Divider />
                      <Button
                        fullWidth
                        style={styles.button}
                        endIcon={<NavigateNextIcon />}
                      >
                        {"Gear Size: " +
                          (effort.gearsize ? effort.gearsize : "N/A")}
                      </Button>

                      <Divider />
                      <Button
                        fullWidth
                        style={styles.button}
                        endIcon={<NavigateNextIcon />}
                      >
                        {"Mesh / Ring Size: " +
                          (effort.mesh_size ? effort.mesh_size : "N/A")}
                      </Button>
                    </Link>
                    <Divider />
                    <Link
                      to={`${process.env.PUBLIC_URL}/effort-page2`}
                      state={{
                        trip: currentTrip,
                        effortNr: idx,
                      }}
                      className="side-nav"
                    >
                      <Button
                        fullWidth
                        style={styles.button}
                        endIcon={<NavigateNextIcon />}
                      >
                        {"Chart Area: " +
                          (effort.chart_area ? effort.chart_area : "N/A")}
                      </Button>
                      <Divider />
                      <Button
                        fullWidth
                        style={styles.button}
                        endIcon={<NavigateNextIcon />}
                      >
                        {"Number of Hauls: " +
                          (effort.number_of_hauls
                            ? effort.number_of_hauls
                            : "N/A")}
                      </Button>

                      <Divider />
                      <Button
                        fullWidth
                        style={styles.button}
                        endIcon={<NavigateNextIcon />}
                      >
                        {"Tow / Soak Time: " +
                          (effort.tow_soak_time.hours
                            ? effort.tow_soak_time.hours +
                              ":" +
                              effort.tow_soak_time.minutes
                            : "N/A")}
                      </Button>
                      <Divider />
                      <Button
                        fullWidth
                        style={styles.button}
                        endIcon={<NavigateNextIcon />}
                      >
                        {"Fishing Depth: " +
                          (effort.fishing_depth !== ""
                            ? effort.fishing_depth +
                              " " +
                              effort.fishing_depth_uom
                            : "N/A")}
                      </Button>
                    </Link>
                    <Divider />
                    <Link
                      to={`${process.env.PUBLIC_URL}/effort-page3`}
                      state={{
                        trip: currentTrip,
                        effortNr: idx,
                      }}
                      className="side-nav"
                    >
                      <Button
                        fullWidth
                        style={styles.button}
                        endIcon={<NavigateNextIcon />}
                      >
                        {"Latitude: " +
                          displayLatitudeLongitude(
                            effort.lat_long_format,
                            effort.latitude_or_loran1
                          )}
                      </Button>
                      <Divider />
                      <Button
                        fullWidth
                        style={styles.button}
                        endIcon={<NavigateNextIcon />}
                      >
                        {"Longitude: " +
                          displayLatitudeLongitude(
                            effort.lat_long_format,
                            effort.longitude_or_loran2
                          )}
                      </Button>
                      <Divider />
                    </Link>
                    {
                      // * Lobster info
                      currentTrip.report_type === "2" && (
                        <Link
                          to={`${process.env.PUBLIC_URL}/effort-page4`}
                          state={{
                            trip: currentTrip,
                            effortNr: idx,
                          }}
                          className="side-nav"
                        >
                          {displayTrapsInWaterQuestion && (
                            <>
                              <Button
                                fullWidth
                                style={styles.button}
                                endIcon={<NavigateNextIcon />}
                              >
                                {`${getFieldLabel(
                                  "effort",
                                  "numTrapsInWater"
                                )}: ${effort.numTrapsInWater}`}
                              </Button>
                              <Divider />
                            </>
                          )}

                          {displayLinesInWaterQuestion && (
                            <>
                              <Button
                                fullWidth
                                style={styles.button}
                                endIcon={<NavigateNextIcon />}
                              >
                                {`${getFieldLabel("effort", "numBuoyLines")}: ${
                                  effort.numBuoyLines
                                }`}
                              </Button>

                              <Divider />
                            </>
                          )}

                          {displayTrapsPerEffortQuestion && (
                            <>
                              <Button
                                fullWidth
                                style={styles.button}
                                endIcon={<NavigateNextIcon />}
                              >
                                {`${getFieldLabel(
                                  "effort",
                                  "numTrapsHauled"
                                )}: ${effort.numTrapsHauled}`}
                              </Button>
                              <Divider />
                            </>
                          )}

                          {displayStringsHauledPerEffortQuestion && (
                            <>
                              <Button
                                fullWidth
                                style={styles.button}
                                endIcon={<NavigateNextIcon />}
                              >
                                {getFieldLabel("effort", "stringsHauled") +
                                  ": " +
                                  effort.stringsHauled}
                              </Button>
                              <Divider />
                            </>
                          )}

                          {displayTrapsPerStringQuestion && (
                            <>
                              <Button
                                fullWidth
                                style={styles.button}
                                endIcon={<NavigateNextIcon />}
                              >
                                {`${getFieldLabel(
                                  "effort",
                                  "numTrapsPerString"
                                )}: ${effort.numTrapsPerString}`}
                              </Button>
                              <Divider />
                            </>
                          )}

                          {displayAverageSoakTimePerEffortQuestion && (
                            <>
                              <Button
                                fullWidth
                                style={styles.button}
                                endIcon={<NavigateNextIcon />}
                              >
                                {getFieldLabel("effort", "avgSoakTime") +
                                  ": " +
                                  (effort.avgSoakTime
                                    ? `${effort.avgSoakTime} hours`
                                    : "")}
                              </Button>
                              <Divider />
                            </>
                          )}
                        </Link>
                      )
                    }
                    <Button fullWidth style={styles.button}>
                      {`Serial Number: ${
                        effort.serial_num !== "" ? effort.serial_num : "N/A"
                      }`}
                    </Button>
                    <Divider />
                    <h3 className="margLeft10">{"Effort Catch"}</h3>
                    <Grid item xs={4}>
                      <CatchReview
                        effortNr={idx}
                        trip_id={currentTrip.trip_id}
                        catch_array={effort.catch ? effort.catch : []}
                      />
                    </Grid>
                  </div>
                );
              } else {
                return null;
              }
            })}
          </Grid>
          <Grid item xs={12}>
            <EffortReviewNav
              trip_id={currentTrip.trip_id}
              client_id={auth.client_id}
              effortNr={effortNr ? effortNr : 0}
              catchNr={currentTrip.catchNr}
              deleteEffort={isExisting === true ? _showConfirm : false}
              types={validation.validations.reportTripType}
            />
          </Grid>
        </Box>
      </Box>
    );
  }

  return (
    <div>
      <TitleBar title="GARFO open VTR" />
      <ErrorAlert error={"Unexpected error"} />
      <Divider />
      <Link
        to={`${process.env.PUBLIC_URL}/home`}
        state={{
          client_id: auth.client_id,
          user_full_name: auth.user_full_name,
        }}
      >
        <Button>Home</Button>
      </Link>
    </div>
  );
}

export default connect(
  mapVtrStateToProps,
  mapDispatchToProps
)(EffortReviewPage);
